<!-- order-list 4 -->

<template>
  <div class="order-page" style="height: 100vh">
    <van-tabs v-model="active" :before-change="beforeChange">
      <van-tab v-for="tab of tabs" :key="tab" :title="tab">
        <van-empty v-if="!orderList || orderList.length < 1" description="暂无数据"></van-empty>

        <order-list-detail :order-detail="orderList" @update="getOrders">
          <template v-if="orderType === 'movie'" #goods-content="prop">
            <div v-for="goods in prop.goodsList.goods" :key="goods.moviename">
              <van-row style="margin: 4px">
                <van-col span="24">{{ goods.cinemaname }}</van-col>
              </van-row>
              <div class="van-hairline&#45;&#45;top"></div>
              <van-card :desc="prop.goodsList.createTime" :num="goods.quantity" :thumb="goods.movielogo"
                :title="goods.moviename">
                <template #price>
                  <img class="price-icon" src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png" />
                  {{ goods.payamount  }}
                </template>

                <template #tags>
                  <van-tag plain style="margin: 4px 0; font-size: 12px" type="danger">不退不换</van-tag>
                </template>
              </van-card>
            </div>
          </template>

          <template v-if="orderType === 'birthday'" #order-info="prop">
            <van-cell v-if="prop.orderInfo.goods[0].code" :border="false" :value="prop.orderInfo.goods[0].code"
              title="验证码"></van-cell>
            <van-cell v-if="prop.orderInfo.goods[0].codeUrl" :border="false" :value="prop.orderInfo.goods[0].codeUrl"
              title="验证链接"></van-cell>
            <van-cell v-if="prop.orderInfo.goods[0].codeImage" :border="false" :value="prop.orderInfo.goods[0].codeImage"
              title="二维码"></van-cell>
          </template>

          <template v-if="orderType === 'movie'" #order-info="prop">
            <van-cell :border="false" :value="prop.orderInfo.goods[0].seats" title="座位"></van-cell>
          </template>
        </order-list-detail>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import OrderListDetail from "@/views/user-center/order-list/goods/order-list-detail";
import { mall_orders_get_order_goods_list } from "@/api/goods-api";

export default {
  name: "order-list",
  components: { OrderListDetail },
  data() {
    return {
      active: 0,
      orderList: [],
      tabs: ["全部", "待支付", "已支付", "已完成", "已取消"],
      statusOrder: null,
      statusPay: null,
      orderType: 'mall',
      cateCode: ''
    };
  },

  props: {
    orderTitle: { type: String, default: "订单列表" },
  },

  created() {
    this.active = parseInt(this.$route.query.tabIndex || 0, 10);
    this.orderType = this.$route.query.orderType;
    this.cateCode = this.$route.query.cateCode;

    // this.getOrders();
    budo_log.info("#103 active=", this.active)
    this.beforeChange(this.active);
  },

  methods: {
    beforeChange(index) {
      this.active = index;
      budo_log.info('#109 active-index:', this.active, this.active === 1)
      if (index === 1) {
        this.statusOrder = 0;
        this.statusPay = 0;
      } else if (index === 2) {
        this.statusPay = 1;
        this.statusOrder = "";
      } else if (index === 3) {
        this.statusOrder = 4;
        this.statusPay = 1;
      } else if (index === 4) {
        this.statusOrder = 3;
        this.statusPay = "";
      } else {
        this.statusOrder = "";
        this.statusPay = "";
      }

      budo_log.info('#127 statusOrder:', this.statusOrder)
      this.getOrders();
    },

    getOrders() {
      mall_orders_get_order_goods_list(this.statusOrder, this.statusPay, 1, 1000, null, this.cateCode).then(res => {
          this.setOrderList(res.data.records);
        }
      );
    },

    setOrderList(data) {
      this.orderList = data.map((item) => {
        let time = item.createTime.split("-").join("/");
        item.countDown =
          new Date(time).setMinutes(new Date(time).getMinutes() + 10) -
          new Date();
        return item;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "order-list";
</style>
